import styled from 'styled-components';

export const Container = styled.div`
  background: #f9fbfd;
  padding: 60px 20px;
  max-width: 1000px;
  margin: 0 auto;
  color: #111;
  line-height: 1.7;
`;

export const TopLine = styled.h1`
  font-size: 2rem;
  color: #010606;
  margin-bottom: 24px;
  text-align: center;
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 40px;
`;
